import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import calenderIcon from "../../../../../assets/images/date-event.svg";
import styles from "./index.module.scss";

interface DateFieldProps {
  label: string;
  value: string;
  name: string;
  onChange: (name: string, value: Date) => void;
}

const DateField = ({ label, value, name, onChange }: DateFieldProps) => {
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [isFirstRender, setIsFirstRender] = useState(true);
  const inputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (value && isFirstRender) {
      setIsFirstRender(false);
      // Convert ISO date string to YYYY-MM-DD format for the input using moment-timezone
      const momentDate = moment(value);
      const formattedDate = momentDate.format('YYYY-MM-DD');
      setSelectedDate(formattedDate);
    }
  }, [value, isFirstRender]);

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    const momentDate = moment(newValue);
    setSelectedDate(newValue);
    onChange(name, momentDate.toDate());
  };

  const showDatePicker = () => {
    const input = inputRef.current;
    if (input) {
      input.showPicker();
    }
  };

  const formatDate = (date: string): string => {
    const momentDate = moment(date);
    return momentDate.format('DD MMM, YYYY');
  };

  return (
    <div className={styles.dateField}>
      <label htmlFor={name} className={styles.label}>
        {label}
      </label>
      <div className={styles.inputWrapper}>
        <input
          type="date"
          id={name}
          name={name}
          value={selectedDate}
          onChange={handleDateChange}
          className={styles.input}
          ref={inputRef}
          onClick={() => showDatePicker()}
        />
        <span className={styles.displayDate}>
          {selectedDate ? formatDate(selectedDate) : "DD MM, YYYY"}
        </span>
        <img src={calenderIcon} alt="Calendar Icon" className={styles.icon} />
      </div>
    </div>
  );
};

export default DateField;